import { authenticatedFetch } from '@/lib/authenticated-fetch';

export async function openAuthenticatedMedia(path: string, filename?: string, download = false) {
  const url = path.startsWith('/api') ? path : `/api${path}`;
  const res = await authenticatedFetch(url);
  if (!res.ok) {
    throw new Error('No se pudo abrir el archivo multimedia.');
  }

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  if (download) {
    anchor.download = filename ?? 'archivo';
  } else {
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
  }
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}
